export default values => {
  const errors = {};

  if (Number.isNaN(Number(values.code))) {
    errors.code = 'Code must be a number';
  }

  return errors;
};
